import { z } from "zod";

import { imagesSchema } from "../imagesSchema";

export const nextUpSchema = z.object({
  type: z.enum(["challenge", "trivia", "deeplink"]),
  title: z.string(),
  image_url: z.url(),
  deeplink: z.string(),
  reason_code: z.string(),
  reason_label: z.string(),
  color_hex: z.string(),
  has_access: z.boolean(),
  has_video: z.boolean(),
  description: z.string(),
  images: imagesSchema,
});

export const nextUpV3Schema = z.object({
  suggestions: nextUpSchema.array(),
});

export type NextUp = z.infer<typeof nextUpSchema>;
export type NextUpV3 = z.infer<typeof nextUpV3Schema>;
